var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"justify-center":"","align-center":""}},[_c('div',[_c('h3',{staticClass:"headline mb-0"},[_vm._v(_vm._s(_vm.$t('dashboard.password_updated')))])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }